import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    Alert,
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { ResetIcon } from '../../../vectors/index';
import { Admin, Employer } from '../types';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import { useResetPassword } from '../hooks/useResetPassword';

type EmployerResetPasswordModalProps = {
    handleClose: () => void;
    item: Employer | Admin;
};

const EmployerResetPasswordModal: FC<EmployerResetPasswordModalProps> = ({
    handleClose,
    item,
}) => {
    const [errorText, setErrorText] = useState<string>('');
    const { resetPassword, isResetPasswordLoading } = useResetPassword({ setAlertText: setErrorText })

    const handleSave = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message)
                handleClose();
            },
        };
        resetPassword({ user_id: item.id }, options)
    }

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                <ResetIcon />
                <br />
                <Typography variant="h4" m={2} >
                    Reset Password
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                {errorText && <Alert sx={{ margin: "10px 0" }} severity="error">{errorText}</Alert>}
                <Typography variant="body1"
                    m={2}
                    sx={{ fontSize: "18px", textAlign: "center" }}>Clicking the button below will send a link to email address that will enable you to change your password.</Typography>
                <LoadingButton
                    fullWidth
                    loading={isResetPasswordLoading}
                    disabled={isResetPasswordLoading}
                    startIcon={<RotateLeftIcon />}
                    sx={{marginTop:2, marginBottom:2}}
                    variant="contained" color="primary" onClick={handleSave}>
                    Reset password
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default EmployerResetPasswordModal;
